import { defineComponent as _defineComponent } from 'vue'
import { TargetsMetric } from '@/models/enums/TargetsMetric';
import { userTargetsService } from '@/services/userTargets.service';
import { computed, reactive, ref, unref } from 'vue';
import useVuelidate from '@vuelidate/core';
import {
  minValue,
  maxValue,
  numeric,
  required,
  requiredIf,
} from '@/utils/validation';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TargetsMenu',
  props: {
    targets: null,
    targetsMetric: null,
    position: { default: 'is-right' }
  },
  emits: ["target-change"],
  setup(__props: any, { expose, emit }: { emit: ((e: 'target-change', value: number[]) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { targets: number[] | undefined, targetsMetric: TargetsMetric | null, position: string };





const { t } = useI18n();

const dropdownRef = ref<any>(null);

const numberOfTargetValues = computed((): number =>
  userTargetsService.store.getMetricNumberOfTargetValues(props.targetsMetric),
);

const hasMultipleTargetValues = computed<boolean>(
  () => numberOfTargetValues.value > 1,
);
const isTargetMetricOEE = computed<boolean>(
  () =>
    props.targetsMetric === TargetsMetric.LaserOee ||
    props.targetsMetric === TargetsMetric.TubeOee,
);

const state = reactive({
  editTarget0: props.targets?.[0] ?? 0,
  editTarget1: props.targets?.[1] ?? 0,
});

const validations = {
  editTarget0: {
    required,
    numeric,
    minValue: minValue(0),
    maxValue: maxValue(isTargetMetricOEE.value ? 100 : 1_000_000),
  },
  editTarget1: {
    required: requiredIf(() => hasMultipleTargetValues.value),
    numeric,
    minValue: minValue(0),
    maxValue: maxValue(isTargetMetricOEE.value ? 100 : 1_000_000),
  },
};
const v$ = useVuelidate(validations, state);

function initialize() {
  state.editTarget0 = props.targets?.[0] ?? 0;
  state.editTarget1 = props.targets?.[1] ?? 0;
}

function updateTarget() {
  const arrayOfNumbers: number[] = [Number(state.editTarget0)];
  if (hasMultipleTargetValues.value) {
    arrayOfNumbers.push(Number(state.editTarget1));
  }
  toggle();
  emit('target-change', arrayOfNumbers);
}
function onDropdownOpenStatusChanged(isOpen: boolean) {
  if (isOpen) {
    initialize();
  }
}

// Called by ThreeDotsOptions
function toggle() {
  dropdownRef.value?.toggle();
}
expose({ toggle });

function getErrorMessage(key: keyof typeof state): string | undefined {
  return unref(v$.value[key].$errors?.[0]?.$message);
}

return { __sfc: true,props, emit, t, dropdownRef, numberOfTargetValues, hasMultipleTargetValues, isTargetMetricOEE, state, validations, v$, initialize, updateTarget, onDropdownOpenStatusChanged, toggle, getErrorMessage }
}

})